// utils/perm.js - decode JWT to read permissions
export function getAccessToken() {
  return localStorage.getItem('token') || localStorage.getItem('accessToken') ||
       sessionStorage.getItem('token') || sessionStorage.getItem('accessToken') || '';
}

export function parseJwt(token) {
  try {
    const [, payload] = token.split('.');
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return {};
  }
}

export function getPermsFromToken() {
  const token = getAccessToken();
  const payload = parseJwt(token || '');
  return Array.isArray(payload.perms) ? payload.perms : [];
}

export function hasPerm(p) {
  return getPermsFromToken().includes(p);
}
